export const nuJobsApp = {
  "MakeSuggestionsView.Card.TagminAvailabilityCalendar.TagminAvailabilityCalendar.handleOpen":
    "see-more-toggler",
  "MakeSuggestionsView.Card.TagminAvailabilityCalendar.CalendarRecord.individualRecord":
    "individual-record",
  "MakeSuggestionsView.Card.TagminAvailabilityCalendar.CalendarRecord.groupedRecordToggler":
    "grouped-record-toggler",
  "PerformerResultsClassic.PerformerResultsClassic.performerResultsRow":
    "performer-row",
  "PerformerResultsClassic.PerformerResultsClassic.performerEmptyRow":
    "performer-row-empty",
  "PerformerResultsPremium.PerformerResultsPremium.quickView": "quickView",
  "MySuggestionsView.MySuggestionsView.downloadSuggestionsButton":
    "DownloadSuggestionsButtonTestId",
  "MySuggestions.MySuggestions.searchInput": "search roles",
  "Components.SelectAllControls.markAsRead": "markAsRead",
  "Components.SelectAllControls.markAsUnread": "markAsUnread",
  "Components.Breakdown.breakdownMessage": "breakdown-message",
  "SelfTapeRequest.Title.header": "selftapeRequest-title-header",
  "SelfTapeRequest.Title.breakDownTitle":
    "selftapeRequest-title-breakDownTitle",
  "SelfTapeRequest.Info.description": "selftapeRequest-info-description",
  "SelfTapeRequest.Info.videoInstruction":
    "selftapeRequest-info-videoInstruction",
  "SelfTapeAcceptRejectBlock.Response.Banner": "selfTapeRequest-response",
  "SelfTapeRequests.SendToClientModal.sendToClientButton": "sendToClientButton",
  "SelfTapeRequests.AcceptModal.acceptButton": "acceptButton",
  "BreakdownDetails.Table.row": "bd-table-row",
  "BreakdownDetails.suggestionsLoading.text": "loading-text",
  "BreakdownDetails.PaginationResultStats.text": "pagination-result",
  "JobsPage.Filters.openClosedRolesDropdown": "open-closed-roles-dropdown",
  "MakeSuggestionsView.Card.PerformerCard": "performer-card",
  "MakeSuggestionsView.Suggestion.Submit": "submit-suggestion-button",
  "SuggestionViewAgent.SuggestClient.Button": "suggest-client-button",
  "SuggestionViewAgent.Card.SuggestedPerformer": "suggested-performer-card",
  "BreakdownDetails.SuggestionsSection.photo": "suggest-photo",
  "BreakdownDetails.SuggestionsSection.suggestionDateAndTime":
    "suggest-date-time",
  "BreakdownDetails.SuggestionsSection.msgToCD": "message-to-cd",
  "BreakdownDetails.SuggestionsSection.suggestedPhoto": "suggested-photo",
  "BreakdownDetails.SuggestionsSection.section": "suggestion-section",
};
